import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataTablesResponse } from '../models/datatables';
import { environment } from '../../environments/environment';
import { IssueTrackerIncidenceDatatableDTO, IssueTrackerIncidenceDTO, IssueTrackerIncidenceHighligthDTO, IssueTrackerTagDTO } from '../models/issue-tracker-incidence-dto';
import { IssueTrackerEmailStatusDTO } from '../models/issue-tracker-email-status-dto';
import { Select2Data } from 'ng-select2-component';
import { Status } from '../enums/status';
import { IssueTrackerIncidenceDataDTO } from '../models/issue-tracker-incidence-data-dto';

@Injectable({
  providedIn: 'root'
})

export class IssueTrackerIncidenceService {

  private pathAPI = environment.urlAPI;
  private controller = "IssueTrackerIncidence/";
  /** Cliente HTTP sin interceptores (p. ej. iframe/widget público sin MSAL). */
  private readonly httpNoInterceptors: HttpClient;

  readonly statusData: Select2Data = [
    { label: 'Pendiente', value: Status.Pendiente },
    { label: 'Pendiente marca', value: Status.PendienteMarca },
    { label: 'Pendiente usuario', value: Status.PendienteUsuario },
    { label: 'Finalizado', value: Status.Finalizado }
  ];

  constructor(
    private http: HttpClient,
    httpBackend: HttpBackend
  ) {
    this.httpNoInterceptors = new HttpClient(httpBackend);
  }

  public get(id: string): Observable<IssueTrackerIncidenceDTO> {
    return this.http.get<IssueTrackerIncidenceDTO>(this.pathAPI + this.controller + id);
  }

  /**
   * Lectura pública (rutas /public/*, iframe) sin token Bearer.
   */
  public getPublic(id: string): Observable<IssueTrackerIncidenceDTO> {
    return this.httpNoInterceptors.get<IssueTrackerIncidenceDTO>(this.pathAPI + this.controller + id);
  }

  public post(data: FormData): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  /**
   * Alta desde widget embebido sin MSAL (evita acquireTokenSilent en iframe).
   */
  public postPublic(data: FormData): Observable<any> {
    return this.httpNoInterceptors.post<any>(this.pathAPI + this.controller, data);
  }

  public getDataTable(data: any, filters: string): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/' + filters, data);
  }

  public getMessageByIdData(id: string): Observable<IssueTrackerIncidenceDataDTO> {
    return this.http.get<IssueTrackerIncidenceDataDTO>(this.pathAPI + this.controller + 'GetMessageByIdData/' + id);
  }

  public addMessage(data: FormData): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'AddMessage', data);
  }

  public updateMessage(id: string, data: FormData): Observable<IssueTrackerIncidenceDataDTO> {
    return this.http.put<IssueTrackerIncidenceDataDTO>(this.pathAPI + this.controller + 'UpdateMessage/' + id, data);
  }

  public deleteFileAttachedMessage(id: string): Observable<any> {
    return this.http.delete<any>(this.pathAPI + this.controller + 'DeleteFileAttachedMessage/' + id);
  }

  public addMessageUser(data: FormData): Observable<any> {
    return this.httpNoInterceptors.post<any>(this.pathAPI + this.controller + 'AddMessageUser', data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public getEmailStatus(idData: string): Observable<IssueTrackerEmailStatusDTO> {
    return this.http.get<IssueTrackerEmailStatusDTO>(this.pathAPI + this.controller + 'GetEmailStatus/' + idData);
  }

  public getUserIncidenceList(id: string, page: number, length: number): Observable<IssueTrackerIncidenceDatatableDTO[]> {
    return this.http.get<IssueTrackerIncidenceDatatableDTO[]>(this.pathAPI + this.controller + 'GetUserIncidenceList/' + id + '/' + page + '/' + length);
  }

  public getHighligths(filters: string): Observable<IssueTrackerIncidenceHighligthDTO[]> {
    return this.http.get<IssueTrackerIncidenceHighligthDTO[]>(this.pathAPI + this.controller + 'GetHighligths/' + filters);
  }

  public updateTags(id: string, tags: IssueTrackerTagDTO[]): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'UpdateTags/' + id, tags);
  }

  public getAllTags(): Observable<IssueTrackerTagDTO[]> {
    return this.http.get<IssueTrackerTagDTO[]>(this.pathAPI + this.controller + 'GetAllTags');
  }

  public updateItResponse(id: string, itResponse: string): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'UpdateItResponse/' + id, { ItResponse: itResponse });
  }

  public updatePhoneCallNeeded(id: string, phoneCallNeeded: boolean): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'UpdatePhoneCallNeeded/' + id + '/' + phoneCallNeeded, null);
  }

  public updateNoAutoClose(id: string, noAutoClose: boolean): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'UpdateNoAutoClose/' + id + '/' + noAutoClose, null);
  }

}
